import { createSelector } from 'reselect';

import { IRootState } from '../../../reducers';
import { mapProfessionRewardsResponse } from './mappers';

const professionRewardsSelector = createSelector(
  [
    (state: IRootState) => state.studentEvents,
    (state: IRootState) => state.studentRewards,
    (state: IRootState) => state.sectionRef,
  ],
  (studentEvents, studentRewards, sectionRef) => {
    return mapProfessionRewardsResponse(studentEvents, studentRewards, sectionRef);
  },
);

export default professionRewardsSelector;
